import api from "../../../services/api";
import gridClientBase from "../../../components/gridClientComponentBase";
import cellTemplate from "../../../components/grid/cellTemplate/cellTemplate.vue";
import headerTemplate from "../../../components/grid/headerTemplate/headerTemplate.vue";
import moment from "moment";
import formatcoords from "formatcoords";
import helpers from "../../../shared/fleetbox-helpers";
import cellDeleteCommand from "../../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import cellEditCommand from "../../../components/grid/cellEditCommand/cellEditCommand.vue";
import { bus } from "../../../main";
import { mapGetters } from "vuex";

export default {
	extends: gridClientBase,
	components: {
		"cell-edit-command": cellEditCommand,
		"cell-delete-command": cellDeleteCommand
	},
	props: {
		data: { type: Array, default: [] },
		gridClass: String,
		isRootInEditMode: { type: Boolean, default: false },
		categoriesFilter: { type: Array, default: [] }
	},
	data: function() {
		return {
			showAll: false,
			showTooltipAddItem: false,
			categoriesSelectedFilter: [],

			confirmDeletePoi: false,
			deletePoiAction: null,

			hasGeofencesPermission: false
		};
	},

	created() {
		this.hasSelectedMode = true;
		this.items = this.data;
		this.sort = [{ field: "name", dir: "asc" }];

		if (this.scopes && this.scopes.length > 0)  {
			var pr = this.scopes.find(function(item) {
				return item == "GEOFENCES" || item == "GEOFENCES_LIST_BOX";
			});
			
			if (pr) this.hasGeofencesPermission = true;
		}
		bus.$on("marker-click", this.markerClickHandler.bind(this));
	},
	watch: {
		isRootInEditMode: function() {
			this.isInEditMode = this.isRootInEditMode;
		},
		data: {
			handler() {
				this.items = this.data;
			},
			deep: true
		}
	},
	beforeDestroy() {},
	/* metodi */
	methods: {
		goToGeofence(dataItem) {
			if (dataItem && dataItem.geofences && dataItem.geofences.length > 0) {
				var id = dataItem.id;

				this.$router.push({
					name: "GEOFENCES",
					query: {
						id: id
					}
				});
			}
		},
		markerClickHandler(e) {
			if (e && e.marker) {
				var itemToSelect = this._.find(this.items, function(x) {
					return x.id === e.marker.id;
				});

				var showItemIndex = this.itemToReturnIfIsInEditMode.findIndex(function(x) {
					return x.id == itemToSelect.id;
				});

				var pageSize = this.take;
				var page = parseInt(showItemIndex / pageSize);

				this.skip = this.take * page;

				if (itemToSelect) {
					this.selectRow(itemToSelect);
				}
			}
		},
		internalFiltersToUpdate(e) {
			if (e.field == "poi_category_name") {
				this.categoriesSelectedFilter = [];
			}
		},
		onHeaderVisibleChange(visible) {
			for (var i = 0; i < this.data.length; i++) {
				var item = this.data[i];
				if (item && this._.isNull(item.visible) === false) {
					item.visible = visible;
				}
			}
		},
		addItemClick(itemType) {
			this.showTooltipAddItem = false;

			this.$emit("add-item-click", itemType);
		},
		showAddItemMenu: function() {
			if (this.isInEditMode) this.showTooltipAddItem = !this.showTooltipAddItem;
		},
		switchEditMode: function() {
			this.isInEditMode = !this.isInEditMode;
			this.$emit("switch-edit-mode", this.isInEditMode);
		},
		editRowItem(e) {
			this.$emit("on-edit-row-item", e.dataItem);
		},
		removeById(e) {
			var self = this;

			var deletePoiAction = function(e) {
				self.remove(e);
				if (e) {
					if (self.isInEditMode) {
						self.$emit("remove-item", e.dataItem, self.confirmDeletePoi);
					}
				}

				self.confirmDeletePoi = false;
			};

			this.confirmDeletePoi = true;
			this.deletePoiAction = function() {
				deletePoiAction(e);
			};
		},
		undoDeletePoiAction() {
			this.confirmDeletePoi = false;
			this.deletePoiAction = null;
		},
		booleanSwitchChange(e) {},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		formattedDate(date) {
			var d = moment(date);

			return d.format("DD/MM/YYYY HH:mm");
		},
		formattedCoordinates(lat, lon) {
			return helpers.formatCoordinate(lat, "lat") + ", " + helpers.formatCoordinate(lon, "lon");
		}
	},
	computed: {
		...mapGetters(["scopes"]),
		totalItems: function() {
			return this.data.length;
		},
		allAreShown() {
			var self = this;
			if (this.data && this.data.length > 0) {
				var filtersData = this.data.filter(function(item) {
					return self._.isNull(item.visible) === false;
				});

				if (filtersData.length > 0) {
					return filtersData.every(function(item) {
						return item.visible === true;
					});
				}

				return false;
			}

			return false;
		},
		columns: function() {
			var col = [
				{
					field: "poi_category_icon_image",
					title: "",
					width: "50",
					headerCell: "myHeaderTemplate",
					sortable: false,
					cell: "myCellTemplate",
					format: "image-map"
				},
				{
					field: "visible",
					title: "",
					width: "45",
					headerCell: "myHeaderImagesSwitchTemplate",
					sortable: false,
					cell: "myCellTemplate",
					format: "booleanSwitch"
				},
				{
					field: "name",
					title: "Nome",
					width: "350",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "location.address",
					title: "Indirizzo",
					width: "625",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				// {
				// 	field: "location.city",
				// 	title: "Città",
				// 	width: "140",
				// 	headerCell: "myHeaderTemplate",
				// 	filterable: true
				// },
				{
					field: "poi_category_name",
					title: "Categoria",
					width: "230",
					headerCell: "myCategoryHeaderTemplate",
					filterable: true
				},
				{
					field: "",
					title: "",
					width: "",
					headerCell: "",
					filterable: false
				}
			];

			if (this.hasGeofencesPermission) {
				col.push({
					field: "geofences",
					title: "Geofence",
					width: "90",
					headerCell: "myHeaderTemplate",
					sortable: false,
					filterable: false,
					cell: "myGeofenceCellTemplate"
				});
			}

			col.push({
				cell: "myEditCommandTemplate",
				width: "45px",
				sortable: false,
				headerCell: "myHeaderTemplate",
			});
			col.push({
				cell: "myDeleteCommandTemplate",
				width: "45px",
				sortable: false,
				headerCell: "myHeaderTemplate"
			});

			return col;
		}
	}
};
